import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Icon,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
  Button,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import { FaPlus, FaEdit } from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";

const EditGuardianModal = ({
  isOpen,
  onClose,
  guardian,
  onGuardianUpdated,
}) => {
  const [formData, setFormData] = useState({});
  const toast = useToast();

  // Update the form data whenever the guardian prop changes
  useEffect(() => {
    if (guardian) {
      setFormData(guardian);
    }
  }, [guardian]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.put(
        `${BASE_URL}/admin/guardian/update_guardian.php`,
        {
          user_id: formData.user_id, // Ensure you send the user_id
          ...formData,
          pass: sessionStorage.getItem("user_id"),
        }
      );

      if (response.data.success) {
        toast({
          title: "Update Successful",
          description: "Guardian details updated successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        onGuardianUpdated();
        onClose(); // Close the modal after successful update
      } else {
        toast({
          title: "Update Failed",
          description: response.data.message || "Failed to update guardian.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: error.message || "Failed to update guardian.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      motionPreset="slideInBottom"
    >
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
      <ModalContent
        borderRadius="lg"
        boxShadow="xl"
        bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
        color="gray.700"
        p={6}
        maxW="700px"
        maxH="550px"
        overflowY="auto"
      >
        <ModalHeader
          fontSize="xl"
          fontWeight="bold"
          textAlign="center"
          color="teal.600"
        >
          <Icon as={FaEdit} boxSize={5} mr={2} />
          Edit Guardian
        </ModalHeader>

        <ModalCloseButton />
        <ModalBody
          overflowY="auto"
          px={4}
          css={{
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-track": {
              background: "rgba(255, 255, 255, 0.2)",
              borderRadius: "10px",
              backdropFilter: "blur(8px)",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "rgba(173, 216, 230, 0.6)",
              borderRadius: "10px",
              backdropFilter: "blur(8px)",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "rgba(173, 216, 230, 0.9)",
            },
          }}
        >
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
            {[
              "name",
              "address",
              "email",
              "relation",
              "contact_no",
              "nation_id",
              "state_id",
              "district_id",
              "place",
            ].map((field) => (
              <FormControl mb={4} key={field}>
                <FormLabel>
                  {field.charAt(0).toUpperCase() +
                    field.slice(1).replace("_", " ")}
                </FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  name={field}
                  value={formData[field] || ""}
                  onChange={handleChange}
                />
              </FormControl>
            ))}
          </SimpleGrid>
        </ModalBody>
        <ModalFooter>
          <Button
            bgGradient="linear(to-r, teal.400, teal.600)"
            color="white"
            _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
            colorScheme="blue"
            mr={3}
            onClick={handleSubmit}
          >
            Save
          </Button>
          {/* <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button> */}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditGuardianModal;
